<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <h1>{{projectType | capitalize}} Revision Edit Selection</h1>
    This permit has had <strong>{{form.revisionCount}} revisions</strong> to date.<br>
    A permit may have a maximum of 6 revisions before it is cancelled and a new permit must be obtained.

    <div class="mt-3">
      <label>
        <strong>What information would you like to update for this permit? Check all that apply:</strong>
      </label>
      <base-checkbox v-model="form.changesEmail"
                     label="Contact Email"
                     @change="resetHoldCancel"/>
      <base-checkbox v-model="form.changesContractorInfo"
                     label="Contractor Information"
                     @change="resetHoldCancel" />
      <base-checkbox v-model="form.changesAbatementInfo"
                     v-if="form.projectType.toLowerCase() === 'asbestos'"
                     label="Abatement Information"
                     @change="resetHoldCancel" />
      <base-checkbox v-model="form.changesPermitDates"
                     label="Permit Dates And Times"
                     @change="resetHoldCancel" />
      <base-checkbox v-model="form.changesDisposalSite"
                     label="Disposal Site"
                     @change="resetHoldCancel"/>
      <base-checkbox v-model="form.changesWasteTransporter"
                     label="Waste Transporter"
                     @change="resetHoldCancel"/>
      <base-checkbox v-model="form.projectHold"
                     label="Project on HOLD (a new Revision Form must be filled out with new dates when resuming work)" />
      <base-checkbox v-model="form.projectCancel"
                     label="Cancel Project" />
    </div>
    <button class="btn btn-success mt-3"
            v-bind:disabled="invalidRevision"
            @click="submitRevision"
            @keyup.enter="submitRevision">
      &#10003; Submit
    </button>
  </div>
</template>

<script>
import BaseCheckbox from '~/components/BaseCheckbox';
import { PermitApplication, RevisionApplication } from '~/js/FormObjects';
import { getRevisionApplication } from '~/js/FormFunctions';
import { CapitalizeFilter } from '~/js/Mixins';

export default {
  name: 'RevisionSelect',
  components: { BaseCheckbox },
  props: ['projectType', 'id'],
  mixins: [CapitalizeFilter],
  data() {
    return {
      form: new RevisionApplication(new PermitApplication('Demolition')),
      fetchingData: false,
    };
  },
  mounted() {
    const tempForm = this.$store.getters.temporaryForm;
    this.$store.commit('temporaryForm', null);
    if (!tempForm) {
      this.fetchingData = true;
      const self = this;
      getRevisionApplication(this.id)
        .then((data) => {
          self.fetchingData = false;
          this.form = data;
          this.autoSelectOMandSubmit();
        })
        .catch((error) => {
          self.error = error;
          self.fetchingData = false;
          self.$notify('Error getting permit record', 'error');
          self.$router.push({ name: 'RevisionSearch', params: { projectType: self.projectType } });
        });
    } else {
      this.form = tempForm;
      this.autoSelectOMandSubmit();
    }
  },
  computed: {
    invalidRevision() {
      if (this.form.projectOMUpdate) {
        return false;
      }
      return this.form.revisionCount >= 6;
    },
  },
  watch: {
    'form.projectHold': function (newVal) {
      if (newVal) {
        this.resetForm();
        this.form.projectHold = true;
      }
    },
    'form.projectCancel': function (newVal) {
      if (newVal) {
        this.resetForm();
        this.form.projectCancel = true;
      }
    },
  },
  methods: {
    resetForm() {
      this.form.changesEmail = false;
      this.form.changesSiteInfo = false;
      this.form.changesContractorInfo = false;
      this.form.changesPermitDates = false;
      this.form.changesDisposalSite = false;
      this.form.changesWasteTransporter = false;
      this.form.projectHold = false;
      this.form.projectCancel = false;
    },
    setOMForm() {
      this.form.changesEmail = true;
      this.form.changesSiteInfo = true;
      this.form.changesContractorInfo = true;
      this.form.changesPermitDates = true;
      this.form.changesDisposalSite = true;
      this.form.changesWasteTransporter = true;
      this.form.projectHold = false;
      this.form.projectCancel = false;
    },
    resetHoldCancel() {
      this.form.projectHold = false;
      this.form.projectCancel = false;
    },
    // setForm: function (tempForm) {
    //   this.form = Object.assign({
    //     changesEmail: false,
    //     changesSiteInfo: false,
    //     changesContractorInfo: false,
    //     changesPermitDates: false,
    //     changesDisposalSite: false,
    //     changesWasteTransporter: false,
    //     projectHold: false,
    //     projectCancel: false,
    //     permitId: tempForm.id
    //   }, tempForm)
    // },
    submitRevision() {
      this.$store.commit('temporaryForm', this.form);
      this.$router.push({ name: 'RevisionForm', params: { projectType: this.projectType, id: this.id } });
    },
    autoSelectOMandSubmit() {
      if (this.form.projectOMUpdate) {
        this.setOMForm();
        this.submitRevision();
      }
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0;
}
</style>
